import { render, staticRenderFns } from "./FacturaDeudorDetalle.vue?vue&type=template&id=7ff9402d"
import script from "./FacturaDeudorDetalle.vue?vue&type=script&lang=js"
export * from "./FacturaDeudorDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports